import { KeyValue } from '@/main/models/common';
import { ModelRequest } from '@/main/models/request';
import { IInitialReducerData } from '@/main/services/reducerUtils';

export enum ModelTypes {
  GET_MODELS = '@model/GET_MODELS',
  SAVE_MODELS = '@model/SAVE_MODELS',
  RESET_REDUCER_MODELS = '@model/RESET_REDUCER_MODELS'
}

export interface ModelState {
  readonly models: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
  readonly isolated: {
    [key: string]: IInitialReducerData;
  };
}

export interface GetModels {
  type: typeof ModelTypes.GET_MODELS;
  payload: {
    request: ModelRequest;
    keyReducer: string;
  };
}

export interface SaveModels {
  type: typeof ModelTypes.SAVE_MODELS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
    keyReducer: string;
  };
}

export interface ResetReducerModels {
  type: typeof ModelTypes.RESET_REDUCER_MODELS;
  payload: {
    keyReducer: string;
  };
}

export type ModelActionTypes = GetModels | SaveModels | ResetReducerModels;

